import type { CurrentSeasonAreas, MethodologyResponse, Phenomenon } from '@protector/entities/phenomenon/models';
import type { UUID } from '@protector/utils/types';

export const PhenomenonActionsTypes = {
  LOAD_PHENOMENON_BY_METHODOLOGY: '[Phenomenon] Load Phenomenon by Methodology',
  LOAD_PHENOMENON_BY_METHODOLOGY_SUCCESS: '[Phenomenon] Load Phenomenon by Methodology Success',
  LOAD_PHENOMENON_BY_METHODOLOGY_FAILURE: '[Phenomenon] Load Phenomenon by Methodology Failure',

  LOAD_METHODOLOGIES: '[Phenomenon] Load Methodologies',

  LOAD_METHODOLOGY_BY_AREA: '[Phenomenon] Load Methodology By Area',
  LOAD_METHODOLOGY_BY_AREA_SUCCESS: '[Phenomenon] Load Methodology By Area Success',
  LOAD_METHODOLOGY_BY_AREA_FAILURE: '[Phenomenon] Load Methodology By Area Failure',

  LOAD_METHODOLOGY: '[Phenomenon] Load Methodology',
  LOAD_METHODOLOGY_SUCCESS: '[Phenomenon] Load Methodology Success',
  LOAD_METHODOLOGY_FAILURE: '[Phenomenon] Load Methodology Failure'
} as const;

export const LoadMethodologies = (propertyId: UUID) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGIES,
    payload: propertyId
  };
};

export const LoadPhenomenonByMethodologyFailure = (err: string) => {
  return {
    type: PhenomenonActionsTypes.LOAD_PHENOMENON_BY_METHODOLOGY_FAILURE,
    payload: err
  };
};

export const LoadPhenomenonByMethodology = (methodologyIds: UUID[]) => {
  return {
    type: PhenomenonActionsTypes.LOAD_PHENOMENON_BY_METHODOLOGY,
    payload: methodologyIds
  };
};

export const LoadPhenomenonByMethodologySuccess = (phenomena: Phenomenon[]) => {
  return {
    type: PhenomenonActionsTypes.LOAD_PHENOMENON_BY_METHODOLOGY_SUCCESS,
    payload: phenomena
  };
};

export const LoadMethodologyByArea = (propertyId: UUID, id: UUID, endsAt?: string) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY_BY_AREA,
    payload: { propertyId, id, endsAt }
  };
};

export const LoadMethodologyByAreaSuccess = (response: CurrentSeasonAreas[]) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY_BY_AREA_SUCCESS,
    payload: response
  };
};

export const LoadMethodologyByAreaFailure = (error: string) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY_BY_AREA_FAILURE,
    payload: error
  };
};

export const LoadMethodology = (id: UUID) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY,
    payload: id
  };
};

export const LoadMethodologySuccess = (response: MethodologyResponse) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY_SUCCESS,
    payload: response
  };
};

export const LoadMethodologyFailure = (error: string) => {
  return {
    type: PhenomenonActionsTypes.LOAD_METHODOLOGY_FAILURE,
    payload: error
  };
};
